import React from 'react';

import { Segment, Icon } from '@mairistem/composants';

interface BlocTileProps {
  children?: React.ReactNode;
  title: string;
  stats?: string | number;
  onClick?: () => void;
  statsColor?: string;
  style?: React.CSSProperties;
  'data-testid'?: string;
}
const BlocTile = (props: BlocTileProps) => {
  const {
    children,
    title,
    stats,
    onClick,
    statsColor,
    style,
    'data-testid': dataTestId,
  } = props;

  const [hoverDoubleNat, setHoverDoubleNat] = React.useState(false);

  const handleNavigateToLink = () => {
    if (onClick) {
      onClick();
    }
  };

  const segmentStyle = {
    backgroundColor: '#f9f9f9',
    border: 'none',
    boxShadow: 'none',
    margin: 0,
    flex: 1,
  };

  const clickableSegmentStyle = {
    ...segmentStyle,
    cursor: 'pointer',
    transition: 'transform 0.2s, box-shadow 0.2s',
  };

  const doubleNatSegmentStyle = {
    ...clickableSegmentStyle,
    transform: hoverDoubleNat ? 'scale(1.02)' : 'scale(1)',
    boxShadow: hoverDoubleNat ? '0 12px 30px rgba(0, 0, 0, 0.18)' : 'none',
  };

  const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
  };

  const badgeStyle = {
    fontWeight: '600',
    fontSize: '2.5em',
    padding: '10px',
    borderRadius: '4px',
    minWidth: '60px',
    textAlign: 'center',
  };

  const titleStyle = {
    fontWeight: '600',
    textDecoration: onClick ? 'underline' : 'none',
  };

  return (
    <Segment
      data-testid={dataTestId}
      style={{
        ...style,
        ...doubleNatSegmentStyle,
        cursor: onClick ? 'pointer' : 'default',
        position: 'relative',
      }}
      onMouseEnter={() => onClick && setHoverDoubleNat(true)}
      onMouseLeave={() => onClick && setHoverDoubleNat(false)}
      onClick={onClick ? handleNavigateToLink : undefined}
    >
      {onClick && (
        <Icon
          name="list"
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            backgroundColor: 'white',
          }}
        />
      )}
      <div style={containerStyle}>
        {/* @ts-expect-error Type error */}
        <span
          style={{
            ...badgeStyle,
            // Assombrir la couleur du background pour le texte
            color: `color-mix(in srgb, ${statsColor}, black 40%)`,
            backgroundColor: statsColor,
          }}
          data-testid={dataTestId && `${dataTestId}-chiffre`}
        >
          {stats ?? 0}
        </span>
        <div style={titleStyle}>{title}</div>
      </div>
      {children}
    </Segment>
  );
};

export default BlocTile;
